import logs from '../../packages/kandy/src/logs/plugin'
import config from '../../packages/kandy/src/config'
import events from '../../packages/kandy/src/events'

/**
 * This is a list of base plugins that most solutions will need. These plugins provide service-like capabilities
 * to the SDK.
 */
export default [
  { name: 'logs', fn: logs },
  { name: 'config', fn: config },
  { name: 'events', fn: events }
]
